/**
 * @Module: Stored Recipe Type
 * @Status: Ready
 * @Summary: Firestore-persisted recipe shape — extends Recipe with user metadata
 * @Description: StoredRecipe adds timestamps, favorites, cook tracking, user tags,
 *   and a schema version to the base Recipe type. All Timestamp fields are
 *   ISO-8601 strings on the client side — converters handle the translation.
 * @NextSteps: Add migration logic when schemaVersion bumps beyond 2
 */

import type { Recipe } from './recipe';

export interface StoredRecipe extends Recipe {
  /** ISO-8601 creation timestamp (converted from Firestore Timestamp) */
  createdAt: string;
  /** ISO-8601 last-update timestamp */
  updatedAt: string;
  /** User-toggled favorite flag */
  isFavorite: boolean;
  /** Number of times the user has cooked this recipe */
  cookCount: number;
  /** ISO-8601 timestamp of last cook, or null if never cooked */
  lastCookedAt: string | null;
  /** User-added tags beyond the recipe's own meta.tags */
  userTags: string[];
  /** Document schema version — always 2 for current schema */
  schemaVersion: number;
}

/** Current schema version written to every new document. */
export const CURRENT_SCHEMA_VERSION = 2;
